import { View } from 'react-native'
import { useCurrencyDecimals, useCurrencySign } from 'hooks/useCurrency'
import cn from '@ui/utils/cn'
import Border from '@ui/effects/Border'
import Gradient from '@ui/effects/Gradient'
import { VariableDiscountConfiguration } from '@ca/common/types'
import { colors } from '@ui/colors'
import { sPricePrefix } from '@/price/PriceInfo/styles'
import { TextDiscount } from '@ca/common/types'
import Typography from '@ui/typography'
import { leadingNone } from '@ui/typography/styles'
import { formatPrice } from './PricePackage'

interface Props {
  discount: VariableDiscountConfiguration | TextDiscount
}

const VariableDiscountValue = ({
  discount,
}: {
  discount: VariableDiscountConfiguration
}) => {
  const { amount, type } = discount
  const currencySign = useCurrencySign()
  const decimals = useCurrencyDecimals()
  return (
    <>
      {type === 'fixed'
        ? `${formatPrice(amount, decimals)}${currencySign}`
        : `${amount}%`}
    </>
  )
}

const TextDiscountValue = ({ discount }: { discount: TextDiscount }) => {
  const { text } = discount
  return <>{text}</>
}

const color = colors.orange[600]

export default function DiscountPackage({ discount }: Props) {
  const { scope } = discount
  const label = discount.scope === 'text' ? discount.label : undefined

  return (
    <View className="relative inset-0">
      <View className="flex flex-col items-center justify-center gap-1">
        {label && (
          <Typography
            variant="SMB"
            className={cn(sPricePrefix, 'whitespace-nowrap opacity-50')}
            style={{
              minWidth: 256,
            }}
            color={color}
          >
            {label}
          </Typography>
        )}
        <View className="relative inset-0 h-10 justify-center rounded-2xl">
          <Gradient
            colors={[colors.white25, colors.white75]}
            start={[0, 0.5]}
            end={[1, 0.5]}
            className="rounded-2xl"
          />
          <Border style={{ borderColor: color, borderWidth: 2 }} />

          <View className="flex flex-row items-end justify-center gap-1 px-6">
            <Typography
              variant="LGB"
              className={cn('uppercase tracking-[0]', leadingNone)}
              color={color}
            >
              {scope === 'variable' && (
                <VariableDiscountValue discount={discount} />
              )}
              {scope === 'text' && <TextDiscountValue discount={discount} />}
            </Typography>
          </View>
        </View>
      </View>
    </View>
  )
}
